import { createSlice } from "@reduxjs/toolkit";
import { IFacultyConnectDetailSlice } from "../../../models/faculty/facultyConnect";

const initialFacultyConnectState: IFacultyConnectDetailSlice = {
    facultyConnectDetails: undefined,
};

const facultyConnectDetailSlice = createSlice({
    name: "facultyConnect",
    initialState: initialFacultyConnectState,
    reducers: {
        setFacultyConnectDetails: (state, action: { payload: any }) => {
            state.facultyConnectDetails = action.payload;
        },
    },
});

export const { setFacultyConnectDetails } = facultyConnectDetailSlice.actions;

const facultyConnectDetailReducer = facultyConnectDetailSlice.reducer;

export type facultyConnectDetailState = ReturnType<typeof facultyConnectDetailReducer>;

export default facultyConnectDetailReducer;
